import {SchoolSearchResults} from "@stadtlandnetz/core";
import {DropdownSearchOption} from "@stadtlandnetz/forms";

export function convertSchoolSearchResultsToOptions(searchResults: SchoolSearchResults): DropdownSearchOption[] {
    return Object.values(searchResults).map(searchResult => ({
        title: searchResult.name,
        subtitle: `${searchResult.address.street} ${searchResult.address.houseNumber}, ${searchResult.address.postalCode} ${searchResult.address.town}`,
        value: searchResult.id
    }))
}